module.exports = __webpack_public_path__ + "static/media/img2-2.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img2-2.png
// module id = 1432
// module chunks = 3